exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-component[data-v-1790fd2c]{\n  min-height: 0px !important;\n}\n", ""]);

// exports
